import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MarketplaceOrder } from 'src/app/gamification/command-center/models/marketplace-order.model';
import { MarketplaceService } from 'src/app/gamification/command-center/services/marketplace.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
  selector: 'cv-marketplace-orders-modal',
  templateUrl: './marketplace-orders-modal.component.html',
  styleUrls: ['./marketplace-orders-modal.component.scss']
})
export class MarketplaceOrdersModalComponent implements OnInit {

  @Input() items: MarketplaceOrder[];
  @Input() disableList: boolean;

  isLoading = false;
  hasSelector = true;
  selectedRange = 'today';
  orderData: any[] = [];

  possibleRanges = [];
  disableSelector = false;

  constructor(
    public activeModal: NgbActiveModal,
    private marketplaceService: MarketplaceService,
    private cvLocalizationService: CVLocalizationService
  ) {
    this.possibleRanges = [
      { key: 'today', display: this.cvLocalizationService.getCachedText('Controls', 'Today', 'Today') },
      { key: 'week', display: this.cvLocalizationService.getCachedText('Controls', 'This_Week', 'This Week') },
      { key: 'month', display: this.cvLocalizationService.getCachedText('Controls', 'This_Month', 'This Month') }
    ];
  }

  ngOnInit(): void {
    if (this.items) {
      this.hasSelector = false;
      this.isLoading = true;
      setTimeout(() => {
        this.orderData = this.items;
        this.isLoading = false;
      }, 3000);
    } else {
      this.loadData();
    }
  }

  async loadData() {
    this.isLoading = true;
    // Load orders if not loaded
    if (!this.marketplaceService.data.ordersLoaded) {
      await this.marketplaceService.loadMarketplaceOrders();
    }

    let orderData = this.marketplaceService.data.ordersByRange[this.selectedRange];

    // Load products ordered for selected orders
    await this.marketplaceService.loadProductsOrderedForOrders(orderData).then(()=>{
      this.orderData = <MarketplaceOrder[]>orderData;
    });
    this.isLoading = false;
  }

  closeModal(): void {
    this.activeModal.close();
  }
}